/*eslint-disable */
import React from 'react';
import SvgIcon from './SvgIcon';

interface Props {
  width?: number,
  height?: number,
  fill?: string,
}

const FacebookIcon: React.FC<Props> = (props: Props) => {
  const {
    width = 24,
    height = 24,
    fill = '#4267b2'
  } = props;

  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <path fill={fill} d="M0 0v24h24v-24h-24zm16 7h-1.923c-.616 0-1.077.252-1.077.889v1.111h3l-.239 3h-2.761v8h-3v-8h-2v-3h2v-1.923c0-2.022 1.064-3.077 3.461-3.077h2.539v3z" />
    </SvgIcon>
  );
};

export default FacebookIcon
